import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  StyledImageGrid,
  ConcludeContainer,
  WorkReferencesHeading,
  WorkReferenceList,
  WorkExternalLink,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function HoloWork() {
  const ProjectBG = require("../../../../assets/videos/holowork/poster.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="Holowork — collaborative XR for industrial workflows"
      lead={
        <p>
          Holowork combines a web app and HoloLens 2 for planning, training, and
          realtime collaboration: instructional boards with 3D, media, and
          PDFs; tools like scale, locking, and wireframes; multi-user sessions
          and live robot simulation—unifying ARZuKMU and KoMAR objectives.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/1_Holowork.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>ARZuKMU</WorkSectionHeading>
          <p>
            A multi-user HoloLens experience for factory planning—cross-role and
            cross-company collaboration without hierarchical barriers,
            integrating with existing planning tools so teams visualize layouts
            in situ.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <StyledImageGrid src={ProjectBG} alt="" />
        </WorkMediaFrame>
        <WorkTextStack>
          <p>
            Inclusivity and a cloud-based realtime model improve communication
            and shared ownership of outcomes. ARZuKMU provides the foundation for
            transparent, participatory layout evaluation inside Holowork.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/3_Holowork.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>KoMAR</WorkSectionHeading>
          <p>
            Extends Holowork with AR simulation for cobots in assembly workflows.
            Co-developed with BIBA, it supports multi-user safety zones,
            interaction points, and feasibility analysis with spatial accuracy.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/4_Holowork.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <p>
            Simulation modules animate cobot behavior from user input and
            backend data—supporting early, immersive assessment of automation,
            ergonomics, and investment decisions.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/5_Holowork.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <p>
            Holowork merges collaborative layout planning with robotic
            simulation—one modular XR platform for next-generation factory
            design, multi-user workflows, and live data.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <WorkReferencesHeading>Reference links</WorkReferencesHeading>
        <WorkReferenceList>
          <WorkExternalLink
            href="https://cooperants.de/tag/holowork/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cooperants — Holowork project
          </WorkExternalLink>
          <WorkExternalLink
            href="https://www.igcv.fraunhofer.de/de/forschung/referenzprojekte/ARZuKMU_Augmented_Reality_in_der_Fabrikplanung.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Fraunhofer IGCV — AR in factory planning
          </WorkExternalLink>
          <WorkExternalLink
            href="https://www.zukunft-der-wertschoepfung.de/projekte/augmented-reality-fuer-eine-neue-zusammenarbeit-in-der-fabrikplanung-von-kmu-arzukmu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            ARZuKMU project details
          </WorkExternalLink>
          <WorkExternalLink
            href="https://www.ips.biba.uni-bremen.de/projekt.1.html?&project_id=KoMAR"
            target="_blank"
            rel="noopener noreferrer"
          >
            KoMAR — BIBA
          </WorkExternalLink>
        </WorkReferenceList>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "HOLOWORK ASSIST" },
          { label: "Period", value: "09.2019 - 11.2019" },
          { label: "Client", value: "Remon" },
          { label: "Engine & Tools", value: "Unity, AR Foundation, C#" },
          { label: "Platform", value: "Mobile, Hololens" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR, MR, WebGL" },
        ]}
      />
    </WorkProjectShell>
  );
}
